import { CLIENT_CUSTOMER_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { ICreatedCustomerModel, ICustomerModel, IUpdatedCustomerModel } from "./customer.models";
export const createCustomerInfoAPI = async (model: ICreatedCustomerModel) => {
  return await apiClient.postHttp<number>(
    `${CLIENT_CUSTOMER_API}`,
     model
  );
};

export const updatedCustomerInfoAPI = async (model: IUpdatedCustomerModel) => {
  return await apiClient.putHttp(
    `${CLIENT_CUSTOMER_API}`, 
    model
  );
};

export const getCurrentCustomerInfoAPI = async () => {
  return await apiClient.getHttp<ICustomerModel>(
    `${CLIENT_CUSTOMER_API}`,
    undefined
  );
};